import React from "react"

import RequestProxyNumber from "./Request"

export type ProxyNumberProps = {
  tutorId: string
  studentId: string
  proxyNumber: string
}

const ProxyNumber: React.FC<ProxyNumberProps> = ({
  tutorId,
  studentId,
  proxyNumber,
}) => {
  if (!studentId) return <>Please add a student first</>

  return (
    <>
      {proxyNumber ? (
        <a href={`sms:${proxyNumber}`}>{proxyNumber}</a>
      ) : (
        <RequestProxyNumber studentId={studentId} tutorId={tutorId} />
      )}
    </>
  )
}

export default ProxyNumber
